<script lang="ts">
	import Picture from '$lib/components/media/Picture.svelte';
	import { fly } from 'svelte/transition';
	import { cubicInOut } from 'svelte/easing';

	interface Props {
		images: { src: string; alt: string; classes?: Classes }[];
		class?: Classes;
	}

	let { images, class: classes = '' }: Props = $props();
</script>

<div
	class="fixed inset-8 m-auto grid gap-8 max-lg:max-w-lg max-lg:grid-rows-3 lg:max-h-[600px] lg:grid-cols-3 {classes}"
>
	{#each images.slice(0, 3) as { src, alt, classes }, i (src)}
		<div
			class="relative h-full w-full"
			transition:fly|global={{
				y: '-10%',
				delay: i * 100,
				duration: 500,
				easing: cubicInOut
			}}
		>
			<Picture {src} {alt} class={['h-full w-full object-cover lg:max-h-[600px]', classes]} />
			<div class="bg-blue/30 absolute inset-0 mix-blend-color"></div>
		</div>
	{/each}
</div>

<style lang="postcss">
	@reference '$lib/styles/app.css';

	:global(.monotone) {
		filter: grayscale(80%) sepia(60%) hue-rotate(180deg);
	}
</style>
